import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
const store = createStore({
  plugins: [createPersistedState()],
  state: {
    EmailID: "",
    UserId: "",
  },

  getters: {
    get_user_email_id: (state) => state.EmailID,
    get_user_id: (state) => state.UserId,
  },
  mutations: {
    SET_USER_EMAIL_ID(state,user_email_id){
      state.EmailID = user_email_id
    },
    SET_USER_ID(state, user_id) {
      state.UserId = user_id;
    },
  },
  actions: {},
  modules: {},
});

export default store;
